import { AppState } from "../AppState.ts";
import { configurationReducer } from "./configuration";
import { calculationReducer } from "./calculation";
import { AppAction } from "./index.ts";

export const combinedReducers = ({ configuration, calculation }: AppState, action: AppAction) => ({
  configuration: configurationReducer(configuration, action),
  calculation: calculationReducer(calculation, action),
});
